import { Component, Input } from '@angular/core';
import { OrderResult } from '../../../../core/services/orders/order.models';
import { environment } from '../../../../../environments/environment';
import { VoutchersService } from '../../../../core/services/vouchers/vouchers.service';
import { Transaction } from '../../../../core/services/transactions/transactions.model';

@Component({
  selector: 'fuse-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent {

    @Input() order: OrderResult;
    @Input() transactions: Transaction[];
    @Input() dueAmount: number;
    host = environment.apiUrl;

    constructor(
        // private fuseConfig: FuseConfigService,
        public readonly vouchersService: VoutchersService,
    ) { }

    // ngOnInit() {}

    get QRCodeUrl() {
        return `${this.host}/orders/${this.order._id}/qrcode/${this.order.qrcodeToken}`;
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/invoice/invoice.component.ts